<template>
  <div class="box">
    <div class="newsImg" v-if="showNews">
<!--      <img src="/static/head.jpg" alt="" />-->
      <img :src="imageurl">

      <i @click="closeHeadNews" class="el-icon-close"></i>
    </div>
    <!-- <el-dialog @close="closeAlert" :visible="showAlert" top="12vh" width="40%">
      <img
        style="cursor: pointer"
        @click="goto"
        src="/static/alertNews.jpg"
        alt=""
      />
    </el-dialog> -->
    <div class="nav">
      <ul class="locations">
        <li>
          <el-dropdown placement="bottom-start" class="location">
            <a href="javascript:void(0)">
              <i class="el-icon-location-outline"></i> {{ city }}
            </a>
            <el-dropdown-menu slot="dropdown">
              <div class="city">
                <p v-for="(items, index) in cityArr" :key="index">
                  <span
                    v-for="(item, index) in items"
                    class="city-item"
                    :key="index"
                    @click="changeCity(item)"
                    >{{ item }}</span
                  >
                </p>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
      <ul class="detail">
        <li class="first" v-show="!username">
          你好，<router-link
            :to="{ name: 'loginAndRegister', query: { type: 2 } }"
            class="toLogin"
            >请登录</router-link
          >
        </li>
        <li v-show="!username">
          <router-link
            :to="{ name: 'loginAndRegister', query: { type: 1 } }"
            style="color: #ff6900"
            >注册
          </router-link>
        </li>
        <li v-show="!!username">
          <!-- <el-dropdown> -->
          <div class="username-p" style="margin: 0">
            <div class="head_img">
              <img :src="headImg" v-if="headImg">
            </div>
            <span class="username" @click="myInfo">{{ username }} </span>
            <!-- <i
              :class="
                showBussinessList ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              "
              style="font-size: 16px; color: #999"
              v-if="bussniessList.length !== 0"
              @click="chooseBussiness"
            ></i> -->
            <div v-show="showBussinessList" class="box-list">
              <div class="item" @click="changeUser" v-if="userInfo">
                {{ userInfo.username }}(个人)
              </div>
              <div
                v-for="(item, index) in bussniessList"
                class="item"
                :key="index"
                @click="changeBussiness(item.enterpriseId)"
              >
                <div class="img-area">
                  <img v-if="!item.enterpriseLogo" src="~@/assets/no-picture.png" alt="">
                  <img v-else :src="item.enterpriseLogo" />
                </div>
                <div v-if="item.enterpriseName.length < 10">
                  {{ item.enterpriseName }}(企业)
                </div>
                <div v-else>{{ item.shortName }}(企业)</div>
              </div>
            </div>
          </div>
          <!-- <el-dropdown-menu slot="dropdown">
              <div class="my-page">
                <div class="my-info" @click="myInfo">
                  <p>我的主页</p>
                </div>
                <div class="sign-out" @click="signOutFun">
                  <p>退出登录</p>
                </div>
              </div>
            </el-dropdown-menu> -->
          <!-- </el-dropdown> -->
        </li>
        <li v-show="!!username">
          <div class="sign-out" @click="signOutFun">退出</div>
        </li>
        <!-- <li>
          <div placement="bottom-start">
            <a @click="toShoppingCart">
              <i class="el-icon-shopping-cart-2"></i> 购物车
            </a>
          </div>
        </li>
        <li><router-link to="/">网站导航</router-link></li>
        <li><router-link to="/freeback">意见反馈</router-link></li> -->
        <li><router-link to="/authorization">授权查询</router-link></li>
        <!-- <li><div @click="goto"><a>经销商专区</a></div></li> -->
        <!-- <li><router-link to="/">商城首页</router-link></li> -->
        <li><a class="tel">{{titlePhone}}</a></li>
        <!-- <li><a>供应商链接</a></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapActions } from "vuex";
import { getApprovedEnterpriseList, changeEnterpise} from "@/api/user";
import {
  bannersearchHomeBannerInfo,
  promotiongetgetManagePromotionInfo, promotiongetWebPromotionInfo,
  webConfigsearchWebConfigInfoByConfCode
} from "../../api/companies";
export default {
  name: "M-Header",
  created() {
    // this.isLogin();
  },
  data() {
    return {
      city: "浙江",
      cityArr: [
        ["北京", "上海", "天津", "重庆", "广州"],
        ["深圳", "河南", "辽宁", "吉林", "江苏"],
        ["江西", "四川", "浙江", "贵州", "云南"],
        ["西藏", "陕西", "甘肃", "青海", "珠海"],
      ],
      showAlert: true,
      bussniessList: [],
      showBussinessList: false,
      userInfo: JSON.parse(localStorage.getItem("personalInfo")),
      headImg:"",
      titphone:"",
      imageurl:"",
      username:''
    };
  },
  computed: {
    // username() {
    // //   console.log(JSON.parse(localStorage.getItem("loginUserInfo")));
    //   // if (localStorage.getItem("loginUserInfo")) {
    //   //   let a = localStorage.getItem("loginUserInfo");
    //   //   a = JSON.parse(a);
    //   //   return a.username;
    //   // } else {
    //   //   return false;
    //   // }
    //   if (localStorage.getItem("loginUserInfo")) {
    //     if (this.bussniessList.length > 0) {
    //       let item = this.bussniessList.find((v) => v.isCurrentLogin === 1);
    //       if (item) {
    //         let b = "";
    //         if (item.enterpriseName.length > 10) {
    //           b = item.shortName;
    //         } else {
    //           b = item.enterpriseName;
    //         }
    //         this.headImg = item.enterpriseLogo
    //         return b;
    //       } else{
    //         let a = localStorage.getItem("loginUserInfo");
    //         a = JSON.parse(a);
    //         return a.username;
    //       }
    //     } else {
    //       let a = localStorage.getItem("loginUserInfo");
    //       a = JSON.parse(a);
    //       return a.username;
    //     }
    //   } else {
    //     return false;
    //   }
    // },
    showNews() {
      return store.state.showNews;
    },
    titlePhone() {
      return store.state.titlePhone;
    },
    // ...mapState(["userInfo", "shoppingCart"])
  },
  created() {
    let date = localStorage.getItem("closeAlertTime");
    if (date == new Date().getDate()) {
      this.showAlert = false;
    } else {
      this.showAlert = true;
    }
    this.getApprovedEnterpriseList();
  },
  methods: {
    // ...mapActions(["signOut", "isLogin"]),
    changeCity(city) {
      this.city = city;
    },
    goto() {
      window.open("http://vip.gemsafe.cn/login");
    },
    goToPay() {
      this.$router.push("/order");
    },
    myInfo() {
      if (localStorage.getItem("loginUserInfo")) {
        let a = localStorage.getItem("loginUserInfo");
        a = JSON.parse(a);
        if (a.enterpriseId) {
          this.$router.push("/bussinessInfo");
        } else {
          this.$router.push("/editUser");
        }
      }
    },
    signOutFun() {
      localStorage.removeItem("loginUserInfo");
      localStorage.removeItem("personalInfo");
      localStorage.removeItem("Enterinformation");
      location.replace("/");
    },
    toShoppingCart() {
      if (localStorage.getItem("loginUserInfo")) {
        this.$router.push("/shoppingCart");
      } else {
        store.commit("SHOW_LOGIN_BOX");
      }
    },
    closeHeadNews() {
      store.commit("CLOSE_HEAD_NEWS");
    },
    closeAlert() {
      this.showAlert = false;
      localStorage.setItem("closeAlertTime", new Date().getDate());
    },
    // 查询用户审核通过的企业信息
    getApprovedEnterpriseList() {
      if (localStorage.getItem("loginUserInfo")) {
        getApprovedEnterpriseList().then((res) => {
          if (res.data.code == 200) {
            const data = res.data.data;
            const {isEnterprise}=data
            if(!isEnterprise){
              store.commit("CHANGE_USERNAME", JSON.parse(localStorage.getItem("loginUserInfo")).username);
              this.username=JSON.parse(localStorage.getItem("loginUserInfo")).username 
              store.commit("CHANGE_USERNAME", this.username);  
              return
            }
            store.commit("CHANGE_ERP", data?true:false);
            this.bussniessList = Array.isArray(data) ? data : [data];
            localStorage.setItem("Enterinformation", JSON.stringify(this.bussniessList));
            if (this.bussniessList.length > 0) {
              let item = this.bussniessList.find((v) => v.isCurrentLogin === 1);
              if (item) {
                let info = JSON.parse(localStorage.getItem("loginUserInfo"));
                info.username = item.enterpriseName;
                info.creditPayment=item.creditPayment;
                info.isEnterprise=item.isEnterprise;
                info.enterpriseId = item.enterpriseId;
                info.enterprisehortName = item.shortName;
                info.erpCode = item.erpCode;
                info.erpId = item.erpId;
                info.shippingMethod = item.shippingMethod;
                info.shippingMethodDes = item.shippingMethodDes;
                info.shippingMethodFront = item.shippingMethodFront;
                info.custSalePallet = item.custSalePallet;
                info.custLevel = item.custLevel;
                info.marketingLevel = item.marketingLevel;
                localStorage.setItem("loginUserInfo", JSON.stringify(info));
                this.headImg = item.enterpriseLogo
              }
            this.username=this.bussniessList[0].shortName||this.bussniessList[0].enterpriseName
            this.changeBussiness(this.bussniessList[0].enterpriseId)
            }
            store.commit("CHANGE_USERNAME", this.username);
          }
          
        });
      } else {
        return false;
      }
    },
    chooseBussiness() {
      this.showBussinessList = !this.showBussinessList;
    },
    // 切换企业
    changeBussiness(id) {
      // if (this.$route.name == "commitOrder") {
      //   this.$message({
      //     type: "warning",
      //     message: "当前页面是提交页面，无法切换用户！",
      //   });
      //   return;
      // }
      // if (this.$route.name == "intellectQuotedPrice") {
      //   this.$message({
      //     type: "warning",
      //     message: "当前页面无法切换用户！",
      //   });
      //   return;
      // }
      let info = JSON.parse(localStorage.getItem("loginUserInfo"));
      let data = {
        enterpriseId: id,
      };
      changeEnterpise(data).then((res) => {
        if (res.data.code == 200) {
          let item = this.bussniessList.find((v) => v.enterpriseId == id);
          if (item) {
            info.custLevel = item.custLevel;
            info.marketingLevel = item.marketingLevel;
            if (item.enterpriseName.length < 10) {
              info.username = item.enterpriseName;
              info.enterpriseId = item.enterpriseId;
              localStorage.setItem("loginUserInfo", JSON.stringify(info));
              this.headImg = item.enterpriseLogo
            } else {
              info.username = item.shortName;
              info.enterpriseId = item.enterpriseId;
              localStorage.setItem("loginUserInfo", JSON.stringify(info));
              this.headImg = item.enterpriseLogo
            }
          }
          this.showBussinessList = false;
        }
      });
    },
    // 切换个人
    changeUser() {
      if (this.$route.name == "commitOrder") {
        this.$message({
          type: "warning",
          message: "当前页面是提交页面，无法切换用户！",
        });
        return;
      }
      changeEnterpise().then((res) => {
        if (res.data.code == 200) {
          localStorage.setItem("loginUserInfo", JSON.stringify(this.userInfo));
          location.reload();
          this.showBussinessList = false;
          this.headImg = ""
        }
      });
    },
  },
  store,
  mounted() {
    // webConfigsearchWebConfigInfoByConfCode({
    //   confCode:"SERVICE_HOTLINE"
    // }).then(res=>{
    //   this.titphone=res.data.data[0].confValue
    // })
    promotiongetWebPromotionInfo().then(res=>{
      if (res.data.code==200){
        this.imageurl = res.data.data[0]?res.data.data[0].promotionImage:''
      }
    })

  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables.scss";
.box {
  width: 100%;
  background-color: #f6f6f6;
  // border-bottom: 1px solid #cccccc;
  /deep/ .el-dialog {
    background: none;
    border: 0;
    box-shadow: none;
    text-align: center;
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #cccccc;
  }
  /deep/ .el-dialog__headerbtn {
    position: absolute;
    top: 8px;
    right: 83px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 37px;
  }
  .newsImg {
    position: relative;
    img {
      width: 100%;
      cursor: pointer;
    }
    i {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
      color: white;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
.nav {
  margin: 0 auto;
  width: 1152px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.nav ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}
.nav li {
  float: left;
  font-size: 12px;
  font-weight: 400;
  line-height: 36px;
  margin-right: 15px;
}
.nav a {
  text-decoration: none;
  color: #333;
  padding-left: 15px;
  border-left: 1px solid #ccc;
  cursor: pointer;
}
.location a {
  border-left: none;
  padding-left: 0;
}
.nav a:hover {
  color: $mainYellowColor;
}
.location {
  color: #666;
  font-size: 12px;
  display: flex;
  text-align: left;
}
.icon {
  color: $mainYellowColor;
}
.first {
  color: #333;
}
.first a:first-child {
  padding-left: 3px;
  border-left: none;
  color: $mainYellowColor;
}
.city {
  padding: 10px 15px;
}
.city-item {
  cursor: pointer;
  padding: 5px;
}
.city-item:hover {
  color: $mainYellowColor;
}
.person-icon {
  color: $mainYellowColor;
  background-color: #f0cdb2;
}
.username {
  color: #999999;
  margin-right: 5px;
  font-size: 14px;
}
.username:hover {
  color: $mainYellowColor;
}
.tel {
  color: $mainYellowColor !important;
}
.shopping-cart-list {
  padding: 3px 15px;
}
.shopping-cart-box {
  margin: 8px 0px;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px #ccc dotted;
}
.shopping-cart-box:first-child {
  margin-top: 8px;
}
.shopping-cart-img {
  margin-right: 15px;
  width: 40px;
  height: 40px;
}
.shopping-cart-img img {
  width: 100%;
}
.shopping-cart-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
  color: #999999;
}
.shopping-cart-detail {
  color: #999999;
}
.shopping-cart-text {
  color: #ccc;
}
.go-to-buy {
  display: flex;
  justify-content: flex-end;
}
.shopping-cart-null {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cart-null-icon {
  font-size: 38px;
  margin-bottom: 15px;
}
.shopping-cart-null span {
  color: #999999;
  font-size: 12px;
  line-height: 16px;
}
.username-p {
  cursor: pointer;
  position: relative;
  .head_img {
    position: absolute;
    left: -25px;
    top: 6px;
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }
  .box-list {
    position: absolute;
    background: #fff;
    z-index: 999;
    top: 36px;
    left: -5px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    display: inline-block;
    width: 200px;
    .item {
      display: flex;
      height: 30px;
      line-height: 30px;
      justify-content: center;
      align-items: center;
      color: #666666;
      padding: 0 5px;
      .img-area {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 6px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .item:hover {
      background: #f6f6f6;
      color: $mainYellowColor;
    }
  }
}
.my-page {
  padding: 3px 5px;
  width: 180px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.my-page a {
  margin: 0px;
  padding: 0px;
  border: none;
}
.my-info {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
// .my-info:hover {
//   box-shadow: 0px 0px 5px #ccc;
// }
.my-info i {
  font-size: 28px;
}
.my-info p {
  font-size: 12px;
}
.sign-out {
  // padding: 5px;
  // width: 50%;
  // height: 100%;
  // text-align: center;
  cursor: pointer;
  color: #999;
}
// .sign-out:hover {
//   box-shadow: 0px 0px 5px #ccc;
// }
.sign-out i {
  font-size: 28px;
}
.sign-out p {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue